<template>
  <post-dialog/>
  <auth-dialog/>
  <main-menu/>
  <verify-email-dialog/>
  <update-app-dialog/>
</template>

<script>
import PostDialog from '@/components/feed/post/creation/PostDialog.vue';
import AuthDialog from '@/components/header/AuthDialog.vue';
import {mapGetters} from 'vuex';
import MainMenu from '@/components/header/MainMenu.vue';
import VerifyEmailDialog from '@/components/header/auth/VerifyEmailDialog.vue';
import UpdateAppDialog from '@/components/header/auth/UpdateAppDialog.vue';

export default {
  name: 'Dialogs',
  components: {UpdateAppDialog, VerifyEmailDialog, MainMenu, AuthDialog, PostDialog},
  computed: {
    ...mapGetters('auth', ['GUEST']),
  },
  methods: {
    openDialogIfMobileGuest() {
      if (this.webview && this.GUEST && !cookies.get('visited')) {
        this.$dialogs.show('auth', 'default')

        cookies.set('visited', true, '1y');
      }
    },

    /**
     * Compare semantic versions
     * @param {string} version - First version string (e.g. '4.10.0')
     * @param {string} latestVersion - Second version string (e.g. '4.9.5')
     * @returns {number} 1 if v1 > v2, -1 if v1 < v2, 0 if equal
     */
    isVersionOlder(version, latestVersion) {
      const toNumbers = (v) => v.split('.').map(Number);
      const a = toNumbers(version);
      const b = toNumbers(latestVersion);

      const len = Math.max(a.length, b.length);
      for (let i = 0; i < len; i++) {
        const n1 = a[i] || 0;
        const n2 = b[i] || 0;
        if (n1 < n2) return true;
        if (n1 > n2) return false;
      }
      return false; // equal versions
    },
    catchAppVersion() {
      if (!this.webview || typeof window.flutter_inappwebview === 'undefined')
        return;

      const latestVersion = '4.10.0';
      const getVersionFn = window.getWebViewVersion;

      if (typeof getVersionFn !== 'function') {
        this.$dialogs.show('update-mobile-app');
        return;
      }

      const {version} = getVersionFn();
      if (this.isVersionOlder(version, latestVersion)) {
        this.$dialogs.show('update-mobile-app');
      }
    }
  },
  watch: {
    $route(to, from) {
      if (from.name !== undefined) {
        this.$dialogs.closeAll()
      }
      this.openDialogIfMobileGuest();
    },
  },
  mounted() {
    // this.catchAppVersion();
  },
}
</script>
